class Dropdown {
  constructor() {
    this.settings = {
      btn: '.js-dropdown-btn',
      list: '.dropdown-filter-by-menu',
    };
  }

  init() {
    const $list = $(this.settings.list);
    const $term = $list.find('a');
    const $this = this;
    $term.on({
      click(e) {
        e.preventDefault();
        $this.setTerms(this);
      },
    });
  }

  setTerms(item) {
    const $item = $(item);
    const name = $item.data('name');
    const terms = $item.data('filterTerm');
    const mainTerms = $item.data('filterMain');
    const filterName = $item.data('filterName');
    const $this = this;

    $.ajax({
      url: '/wp-admin/admin-ajax.php',
      type: 'POST',
      dataType: 'json',
      data: {
        terms,
        mainTerms,
        action: 'filterExperiences',
      },

      success(response) {
        if (response.success) {
          $this.constructor.appendExperiences(name, response.data, filterName);
        }
      },
      error(response) {
        console.log('error', response);
      },
    });
  }

  static appendExperiences(name, items, filterName) {
    if (items) {
      const $tab = $(`#${name}`);
      const $content = $tab.find('.experience-posts-blocks .highligths-blocks');
      const $template = $tab.find('.template .post-box');
      $content.find('.post-box').remove();
      let newItem = '';
      $tab.find('.heading-title .type').text(filterName);
      Object.keys(items).forEach((key) => {
        const item = items[key];
        newItem = $template.clone();
        newItem
          .find('.image')
          .css('background-image', `url('${item.image.url}')`);
        newItem.find('.image').attr('href', item.link);
        newItem.find('.description').html(item.description);
        newItem.find('.description-mobile').html(item.description);
        newItem.find('.title').text(item.post_title);
        newItem.find('.js-add-wishlist-btn').attr('data-id', item.ID);
        if (item.favorite) {
          newItem.find('.js-add-wishlist-btn').addClass('active');
        }
        newItem.appendTo($content);
      });
    }
  }
}

export default Dropdown;
